import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';


export class ExportDb extends DrEntity {
    description: string;
    enabled: boolean;
    expression: string;
    name: string;
    databaseName: string;
    ipAddress: string;
    username: string;
    password: string;
    port: string;
    type = 'MSSQL';

    constructor(value?: Partial<ExportDb>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class ExportDatabaseTableViewModel extends DrObject {

    model: string;
    original: string;

    constructor(value?: string) {
        super(DrObjectType.EXPORT_DATABASE_TABLE, SupportedRegExType.EXPORT_DATABASE_TABLE);
        if (value) {
            this.model = value;
        }

        if (this.model) {
            this.original = this.model;
        }
    }
}

export class ExportDbViewModel extends DrObject {

    model: Partial<ExportDb>;

    constructor(value?: Partial<ExportDb>) {
        super(DrObjectType.EXPORT_CONNECTION);
        if (value) {
            this.model = value;
        }
    }
}


